import { Box } from "@mui/material";

import PageHeader from "../layout/PageHeader";
import PageToolbar from "../layout/PageToolbar";

import useBrowser from "../../hooks/useBrowser";

const Page = ({
  pageName,
  entityName,
  onToolItemClick,
  includeToolbar,
  items,
  backPath,
  backState,
  children,
}) => {
  const { windowWidth, windowHeight } = useBrowser();

  return (
    <>
      <PageHeader
        pageName={pageName}
        entityName={entityName ? entityName : null}
        backPath={backPath}
        backState={backState}
      />
      {includeToolbar ? (
        <PageToolbar
          onToolItemClick={onToolItemClick}
          items={items}
        />
      ) : null}

      <Box
        sx={{
          height: `${windowHeight - 105 - 32}px`,
          width: `${windowWidth - 4 - 32}px`,
          overflow: "auto",
          padding: "1rem",
          // border: "solid red 1px",
        }}
      >
        {children}
      </Box>
    </>
  );
};

export default Page;
